/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';
import { RichText } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @param {Object} props            Properties passed to the function.
 * @param {Object} props.attributes Available block attributes.
 * @return {WPElement} Element to render.
 */
export default function save({ attributes }) {
  const { content, contentTag, contentString, textAlign, textAlignDesktop } =
    attributes;

  const blockProps = useBlockProps.save({
    className: `wp-element-button-content h-auto ${textAlign} ${textAlignDesktop}`,
  });

  return (
    <>
      {!contentString ? (
        <RichText.Content
          {...blockProps}
          tagName={contentTag}
          value={content}
        />
      ) : (
        <span {...blockProps}>{content}</span>
      )}
    </>
  );
}
